import { Component, Optional, Inject } from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { UntypedFormBuilder } from '@angular/forms';
import { CommonModel } from '../models/common.model';
import { CommonIncidentService } from '../services/common-incident.service';
import { IncidentTypeService } from '../services/incident-type.service';
import { IncidentDialogContext } from '../shared/incident-dialog-context.model';
import { IncidentModalComponent } from '../incident-modal.component';
import { IncidentService } from '../services/incident.service';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ProhibitionService } from '../../prohibition/services/prohibition.service';
import { MvdModalService } from '../../shared/services/modal/mvd-modal.service';
import { EnumDataService } from '../services/enums.DataService';

@Component({
    templateUrl: './common-incident-modal.html'
})

export class CommonModalComponent extends IncidentModalComponent<CommonModel> {

    constructor(public service: CommonIncidentService,
        public dialogRef: MatDialogRef<IncidentModalComponent<CommonModel>>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: IncidentDialogContext<CommonModel>,
        location: PlatformLocation,
        fb: UntypedFormBuilder,
        typeService: IncidentTypeService,
        prohibitionService: ProhibitionService,
        modalService: MvdModalService,
        incidentService: IncidentService,
        EnumDataService: EnumDataService
    ) {
        super(data, prohibitionService, fb, dialogRef, modalService, incidentService, EnumDataService, typeService, location);
        this.service = service;
    }

    protected onLoadIncident(callback: (error?) => void): void {
        this.service.getIncident(this.data.incident.incidentNumberId).subscribe(r => this.onGetIncidentCompleted(r, callback), e => callback(e));
    }

    private onGetIncidentCompleted(incident: CommonModel, callback: (error?) => void): void {
        this.data.incident = incident;

        this.showUserInput = true;

        callback();
    }

    protected onSaveIncident(callback: (error?: any) => void): void {
        this.service.saveIncident(this.data.incident).subscribe(r => { }, callback, callback);
    }

    protected onDeleteIncident(callback: () => void): void {
        this.service.deleteIncident(this.data.incident.incidentNumberId).subscribe(result => { }, e => this.handleError, () => {
            this.dialogRef.close(true);
        });
    }
}
